const ManualCreationStyles = () => ({
  detailsSection: {
    '& .Mui-disabled :not(label):not(.MuiFormLabel-asterisk)': {
      '-webkit-text-fill-color': '#101010',
    },
  },
});

export default ManualCreationStyles;
